import React, {createContext} from 'react';

// Due to new version migration (16 -> 19) changed react.createContext to create context.
const CurrentPatientContext = createContext();

export class CurrentPatientProvider extends React.Component {
  state = {
    value: [],
  };

  updateMessage = newMessage => {
    this.setState({ value: newMessage });
  };

  render() {
    const { children, value } = this.props;
    return (
      <CurrentPatientContext.Provider
        value={{
          currentPatientInfo: value || [],
          updateMessage: this.updateMessage,
        }}
      >
        {children}
      </CurrentPatientContext.Provider>
    );
  }
}

export const CurrentPatientConsumer = CurrentPatientContext.Consumer;

export default CurrentPatientContext;
